import script from "./payError.vue?vue&type=script&lang=ts&setup=true"
export * from "./payError.vue?vue&type=script&lang=ts&setup=true"

import "./payError.vue?vue&type=style&index=0&id=39da4912&lang=scss"

const __exports__ = script;

export default __exports__